import _ from "lodash";


export const DetectDuplicatesName = (data) => {
  let warning = '';
  if (!data || data.length === 0) {
    return warning;
  }
  if (data[0].PsaInstance !== undefined) {
    let warnings = [];
    let groupedByInstance = _.groupBy(data, 'PsaInstance');
    for (const [instance, instanceData] of Object.entries(groupedByInstance)) {
      let instanceDupes = _.chain(instanceData).map(d => d.Name).groupBy().filter(v => v.length > 1).flatten().uniq().value();
      if (instanceDupes.length > 0) {
        warnings.push(`Instance [${instance}] has duplicates [${_.join(instanceDupes, ', ')}]`);
      }
    }
    if (warnings.length > 0) {
      warning = warnings.join(', ');
    }
  } else {
    let dupes;
    dupes = _.chain(data).map(d => d.Name).groupBy().filter(v => v.length > 1).flatten().uniq().value();
    if (dupes.length > 0) {
      warning = ` You have the following duplicates [${_.join(dupes, ', ')}].`;
    }
  }
  return warning;
}

export const DetectDuplicatesNameWarningFunction = (set, data, mappingData) => {
  let warning = DetectDuplicatesName(data);
  set(warning.trim());
}

const detectDuplicateLocations = (locations, type, status) => {
  let warning = '';
  if (locations > 0) {
    let verifyLocations = [];
    for (let i = 0; i < locations.length; i++) {
      for (let j = 0; j < locations[i].length; j++) {
        if (verifyLocations.includes(locations[i][j].ID)) {
          warning += ` Employment Status [${status}] contains duplicate location [${locations[i][j].Name}] for ${type}.`;
        } else {
          verifyLocations.push(locations[i][j].ID);
        }
      }
    }
  }
  return warning;
}

export const ProjectorMapResourceTypeWarningFunction = (set, data, mappingData) => {
  let warning = '';
  if (data && data.length > 0) {
    let groupedByInstance = _.groupBy(data, 'PsaInstance');
    for (const [instance, instanceData] of Object.entries(groupedByInstance)) {
      let verifyPracticesFlagNA = true;
      let verifyPracticesFlagOther = true;
      let verify = [];
      instanceData.forEach(d => {
        if (verifyPracticesFlagNA && d.TypeFlag === 'N/A' && d.PracticeIdList === undefined) {
          verifyPracticesFlagNA = false;
        }
        if (verifyPracticesFlagOther && d.TypeFlag !== 'N/A' && d.PracticeIdList?.length > 0) {
          verifyPracticesFlagOther = false;
        }
        if (!verify[d.employment_status.Name]) {
          verify[d.employment_status.Name] = {
            gdc: 0,
            corporate: 0,
            delivery: 0,
            locations_corporate: [],
            locations_delivery: [],
            na: 0,
            locationUsed: d.LocationIdList !== undefined,
            locationInconsistent: false,
            hasPractices: 0
          }
        }
        verify[d.employment_status.Name].hasPractices += d.PracticeIdList === undefined ? 0 : 1;
        verify[d.employment_status.Name].gdc += d.Gdc ? 1 : 0;
        verify[d.employment_status.Name].corporate += d.TypeFlag === 'CORPORATE' ? 1 : 0;
        verify[d.employment_status.Name].delivery += d.TypeFlag === 'DELIVERY' ? 1 : 0;
        if (d.LocationIdList === undefined) {
          if (verify[d.employment_status.Name].locationUsed) {
            verify[d.employment_status.Name].locationInconsistent = true
          }
        } else {
          if (!verify[d.employment_status.Name].locationUsed) {
            verify[d.employment_status.Name].locationUsed = true;
            verify[d.employment_status.Name].locationInconsistent = true;
          }
          if (d.TypeFlag === 'CORPORATE') {
            verify[d.employment_status.Name].locations_corporate.push(d.LocationIdList);
          } else if (d.TypeFlag === 'DELIVERY') {
            verify[d.employment_status.Name].locations_delivery.push(d.LocationIdList);
          }
        }
        verify[d.employment_status.Name].na += d.TypeFlag === 'N/A' ? 1 : 0;
      });
      if (!verifyPracticesFlagNA) {
        warning += `Instance [${instance}]: Records with flag N/A require practices.`;
      }
      if (!verifyPracticesFlagOther) {
        warning += ` Instance [${instance}]: Records with flag CORPORATE or DELIVERY require no practices.`;
      }
      for (const [status, value] of Object.entries(verify)) {
        if (value.na > 1) {
          warning += ` Instance [${instance}]: There should only be one Employment Status [${status}] ` +
            `record having flag N/A.`;
        } else if (value.na === 1) {
          if (value.corporate > 0 || value.delivery > 0) {
            warning += ` Instance [${instance}]: Employment Status [${status}] can't be combined with ` +
              `CORPORATE or DELIVERY flagged record.`;
          }
          if (value.gdc > 0) {
            warning += ` Instance [${instance}]: Records with flag N/A require GDC equal No.`;
          }
        } else if (value.na === 0) {
          if (value.locationUsed) {
            if (value.locationInconsistent) {
              warning += ` Instance [${instance}]: Employment Status [${status}] has inconsistent use of locations.`;
            }
            if (value.hasPractices > 0) {
              warning += ` Instance [${instance}]: Employment Status [${status}] should not have practices.`;
            }
            if (value.corporate !== value.delivery) {
              warning += ` Instance [${instance}]: Employment Status [${status}] incorrect count of ` +
                `DELIVERY/CORPORATE records.`;
            }
            if (value.gdc > 0 && value.gdc !== (value.corporate + value.delivery)) {
              warning += ` Instance [${instance}]: Employment Status [${status}] contains inconsistent GDC flags.`;
            }
            warning += detectDuplicateLocations(value.locations_corporate, 'CORPORATE', status);
            warning += detectDuplicateLocations(value.locations_delivery, 'DELIVERY', status);
          } else {
            if (value.corporate === 0 || value.delivery === 0
              || value.corporate > 1 || value.delivery > 1) {
              warning += ` Instance [${instance}]: Employment Status [${status}] should have one ` +
                `CORPORATE and DELIVERY record.`;
            } else if (value.corporate === 1 && value.delivery === 1 && value.gdc === 1) {
              warning += ` Instance [${instance}]: Employment Status [${status}] should have consistent ` +
                `GDC set for both records.`;
            }
          }
        }
      }
    }
  }
  set(warning.trim());
};